<div class="right-side-bar-heading">
    FEATURES
</div>
<div class="right-side-bar-content">

    <strong class="m-1">caNanoLab provides access to information on:</strong>
    <ul>
        <li>Nanotechnology Protocols
        </li>
        <li>Nanomaterial Composition
        </li>
        <li>Nanomaterial Characterizations (physico-chemical, in vitro, in vivo)
        </li>
        <li>Nanomaterial Publications
        </li>
    </ul><strong class="m-1">For additional information, see the caNanoLab <a href="https://wiki.nci.nih.gov/x/UKml" target="_blank" rel="nofollow noreferrer">FAQ</a> or <a href="https://wiki.nci.nih.gov/x/14CUBg" target="_blank" rel="nofollow noreferrer">User's Guide</a>
    <br/>
</strong>


</div>
